import { GET_ITEMS, GET_ITEMS_ID, putItems } from "../actions/actionItem";
import { POST_ITEMS, PUT_ITEMS, PUT_ITEMS_VALUE, PUT_VALUE_MASSIVE, VALUE_MASSIVE_ERROR, ITEMS_VALUE_ERROR, CLEAR_MESSAGES } from "../actions/actionItem";


const initialState = {
    allItems: [],
    itemsDetail: [],
    postItems: {},
    putItems: {},
    putItemsValue: {},
    putValueMassive: {},
    message: {},
    error: {},
}

export default function reducerItems(state = initialState, action){
    switch (action.type) {
        case GET_ITEMS:
            return {
                ...state,
                allItems: action.payload
            }
        case GET_ITEMS_ID:
            return {
                ...state,
                itemsDetail: action.payload
            }
        case POST_ITEMS:
            return {
               ...state,
               postItems: action.payload
            }
        case PUT_ITEMS:
            return {
                ...state,
                putItems: action.payload
            }
        case PUT_ITEMS_VALUE:
            return {
                ...state,
                putItemsValue: action.payload,
                message: action.payload
            }
        case ITEMS_VALUE_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case PUT_VALUE_MASSIVE:
            return {
                ...state,
                putValueMassive: action.payload,
                message: action.payload                
            }
        case VALUE_MASSIVE_ERROR:
            return {
                ...state,                
                error: action.payload
        }
        case CLEAR_MESSAGES:
            return {
                ...state,
                message: null,
                error: null
            }    
        default:
            return {...state};
    }
}